var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ToolParameter_1;
import { Utils } from '@symon-ai/wisepipe-common';
import { JSON, JsonDiscriminatorProperty, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { toolParameterSchemaValidation } from '../validations.generated';
export var ToolParameterType;
(function (ToolParameterType) {
    ToolParameterType["GLOBAL"] = "global";
    ToolParameterType["PIPE"] = "pipe";
    /**
     * Same as PIPE, but used inside Incentives as CALC
     */
    ToolParameterType["CALC"] = "calc";
    ToolParameterType["REUSABLE"] = "reusable";
    /**
     * Same as REUSABLE, but used inside formulas as TOOL
     */
    ToolParameterType["TOOL"] = "tool"; // for reuseable logic; should never be saved in DB
})(ToolParameterType || (ToolParameterType = {}));
export var ToolParameterValueType;
(function (ToolParameterValueType) {
    ToolParameterValueType["STRING"] = "string";
    ToolParameterValueType["NUMBER"] = "number";
    ToolParameterValueType["BOOLEAN"] = "boolean";
    ToolParameterValueType["DATE"] = "date";
    ToolParameterValueType["ENUM"] = "enum";
    ToolParameterValueType["COLUMN"] = "column";
    ToolParameterValueType["CALENDAR"] = "calendar";
})(ToolParameterValueType || (ToolParameterValueType = {}));
export const TOOL_PARAMETER_GLOBAL_PIPEID = 'AAAAAAAAAAAAAA';
export const TOOL_PARAMETER_REUSABLE_PIPEID = 'BBBBBBBBBBBBBA';
export const toolParameterSchema = {
    $id: 'urn:wisepipe-base-pipe:ToolParameter',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: 150 },
        type: { type: 'string', enum: Object.values(ToolParameterType) },
        pipeID: { type: 'string', uid: 10 },
        description: { type: 'string', maxLength: 1000 },
        valueType: { type: 'string', enum: Object.values(ToolParameterValueType) },
        createdAt: { type: 'string', format: 'date-time' },
        updatedAt: { type: 'string', format: 'date-time' }
    },
    required: ['name', 'type', 'pipeID', 'valueType'],
    if: {
        properties: { type: { const: ToolParameterType.GLOBAL } }
    },
    then: {
        properties: { pipeID: { type: 'string', const: TOOL_PARAMETER_GLOBAL_PIPEID } }
    },
    else: {
        if: {
            properties: { type: { const: ToolParameterType.REUSABLE } }
        },
        then: {
            properties: { pipeID: { type: 'string', const: TOOL_PARAMETER_REUSABLE_PIPEID } }
        },
        else: {
            if: {
                properties: { type: { const: ToolParameterType.TOOL } }
            },
            then: {
                properties: { pipeID: { type: 'string', const: TOOL_PARAMETER_REUSABLE_PIPEID } }
            }
        }
    }
};
let ToolParameter = ToolParameter_1 = class ToolParameter {
    constructor(name, type, valueType, description, pipeID = '') {
        this.name = name;
        if (type === ToolParameterType.GLOBAL) {
            this.pipeID = TOOL_PARAMETER_GLOBAL_PIPEID;
        }
        else if (type === ToolParameterType.REUSABLE || type === ToolParameterType.TOOL) {
            this.pipeID = TOOL_PARAMETER_REUSABLE_PIPEID;
        }
        else {
            this.pipeID = pipeID;
        }
        this.type = type;
        this.valueType = valueType;
        this.description = description;
        JSON.validate(this, ToolParameter_1);
    }
    static newID() {
        return Utils.newID();
    }
    toString() {
        return `@${this.type}.${this.name}`;
    }
};
ToolParameter = ToolParameter_1 = __decorate([
    JsonSchemaV2(toolParameterSchema, toolParameterSchemaValidation),
    JsonDiscriminatorProperty('valueType')
], ToolParameter);
export { ToolParameter };
//# sourceMappingURL=toolParameter.js.map